<app-spinner></app-spinner>
<div
  class="col-sm-8 col-xs-8 col-md-8 col-lg-8"
  style="padding: 10px"
  *ngIf="entity"
>
  <mat-card class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
    <mat-card-header>
      <mat-card-title>
        <div class="backcontainer">
          <div class="Back pointer" (click)="backtoApiList()">
            <img src="assets/img/icons/shape-1.png" /> <span> Back</span>
          </div>
        </div>
        <div *ngIf="!apiGroup.value.groupId" class="headLabel">
          Create Group
        </div>
        <div *ngIf="apiGroup.value.groupId" class="headLabel">Update Group</div>
      </mat-card-title>
    </mat-card-header>
    <div style="margin-top: 2%"></div>
    <form [formGroup]="apiGroup" class="example-form">
      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
        <div
          class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel"
          style="font-weight: bold"
        >
          Name:
        </div>
        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
          <mat-form-field
            appearance="outline"
            class="example-full-width"
            style="width: 100%"
          >
            <mat-label> Enter Name </mat-label>
            <input
              (keypress)="handleInput($event)"
              matInput
              formControlName="Name"
            />
          </mat-form-field>
          <mat-error *ngIf="!apiGroup.value.Name">Name is Required</mat-error>
          <mat-error *ngIf="!isGroupExists">Name already exists</mat-error>
        </div>
      </div>

      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
        <div
          class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel"
          style="font-weight: bold"
        >
          Input Entities:
        </div>
        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
          <img
            style="padding: 8px; cursor: pointer"
            src="assets/img/icons/group-31.png "
            (click)="AddEntity()"
            matTooltip="Add Entity"
            matTooltipPosition="below"
          />
          <mat-error *ngIf="haveEntity"
            >Please select atleast one entity</mat-error
          >
        </div>
      </div>

      <div
        class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
        style="height: 153px; overflow: auto"
      >
        <div
          *ngFor="let entity of entity | orderBy : 'name'"
          class="col-sm-6 col-xs-6 col-md-3 col-lg-3"
        >
          <mat-checkbox
            class="EntityList"
            style="text-overflow: inherit"
            (change)="onChange($event.checked, entity.name)"
            [checked]="checkedentity(entity)"
            >{{ entity.name }}</mat-checkbox
          >
        </div>
      </div>

      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
        <div
          class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel"
          style="font-weight: bold"
        >
          Apis:
        </div>
        <div class="col-sm-12 col-xs-12 col-md-10 col-lg-10">
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node
              *matTreeNodeDef="let node"
              matTreeNodeToggle
              matTreeNodePadding
            >
              <div class="Rounded-copy" style="width: 56%; margin-left: 4%">
                <label style="max-width: 80%">{{ node.sourceName }}</label>

                <img
                  (click)="deleteApi(node)"
                  *ngIf="node.sourceName != 'Parent'"
                  matTooltip="Delete"
                  matTooltipPosition="right"
                  class="Api-GroupIcon-delete pointer"
                  src="assets/img/icons/forma-1.png "
                />

                <img
                  (click)="editApimanager(node)"
                  *ngIf="node.sourceName != 'Parent'"
                  matTooltip="Edit"
                  matTooltipPosition="left"
                  class="Api-GroupIcon-edit pointer"
                  src="assets/img/icons/forma-1-copy-2.png"
                />

                <img
                  (click)="addNewItem(node)"
                  matTooltip="Add"
                  matTooltipPosition="left"
                  class="Rounded-Rectangle-1-copy-6 Api-GroupIcon-Add pointer"
                  src="assets/img/icons/rectangle-2-copy-2.svg"
                />
              </div>
            </mat-tree-node>

            <mat-tree-node
              *matTreeNodeDef="let node; when: hasChild"
              matTreeNodePadding
            >
              <div
                mat-icon-button
                matTreeNodeToggle
                [attr.aria-label]="'toggle ' + node.filename"
              >
                <mat-icon class="mat-icon-rtl-mirror">
                  {{
                    treeControl.isExpanded(node)
                      ? "expand_more"
                      : "chevron_right"
                  }}
                </mat-icon>
              </div>

              <div class="Rounded-copy" style="width: 56%">
                <label class="pointer" style="max-width: 80%">{{
                  node.sourceName
                }}</label>

                <img
                  (click)="deleteApi(node)"
                  *ngIf="node.sourceName != 'Parent'"
                  matTooltip="Delete"
                  matTooltipPosition="right"
                  class="Api-GroupIcon-delete pointer"
                  src="assets/img/icons/forma-1.png "
                />

                <img
                  *ngIf="node.sourceName != 'Parent'"
                  (click)="editApimanager(node)"
                  matTooltip="Edit"
                  matTooltipPosition="left"
                  class="Api-GroupIcon-edit pointer"
                  src="assets/img/icons/forma-1-copy-2.png "
                />

                <img
                  (click)="addNewItem(node)"
                  matTooltip="Add"
                  matTooltipPosition="left"
                  class="Rounded-Rectangle-1-copy-6 Api-GroupIcon-Add pointer"
                  src="assets/img/icons/rectangle-2-copy-2.svg"
                />
              </div>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>

      <div
        class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
        style="margin-top: 2%"
      >
        <div
          class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel"
          style="font-weight: bold"
        >
          Url:
        </div>
        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
          <mat-form-field
            appearance="outline"
            class="example-full-width"
            style="width: 100%"
          >
            <input
              matInput
              disabled
              value="{BaseApiURL}/api/Dashboard/Dashboard/Search"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
        <div
          class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel"
          style="font-weight: bold"
        >
          Input Json:
        </div>
        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
          {{ inputJson }}
        </div>
      </div>

      <div
        class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
        style="margin-top: 2%"
      >
        <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2"></div>
        <div class="col-sm-6 col-xs-6 col-md-4 col-lg-4">
          <!-- <button [disabled]="!apiGroup.valid"  mat-flat-button style="width:50%"
							class="btn" (click)="saveGroup()">
						Save
					</button> -->
          <button
            mat-flat-button
            style="width: 50%"
            class="btn"
            (click)="saveGroup()"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </mat-card>
</div>

<div class="col-sm-4 col-xs-4 col-md-4 col-lg-4" style="padding: 10px">
  <div class="col-md-12">
    <mat-card class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
      <mat-card-header>
        <mat-card-title>Sample Request </mat-card-title>
        <mat-form-field appearance="fill" style="width: 100%; margin-top: 10px">
          <mat-label>Select Language</mat-label>
          <!-- <mat-select [(ngModel)]="selectedLanguage">
            <mat-option value="C#">C#</mat-option>
            <mat-option value="Python">Python</mat-option>
            <mat-option value="Java">Java</mat-option>
            <mat-option value="PHP">PHP</mat-option>
          </mat-select> -->

          <mat-select
            disableRipple
            formControlName="key"
            (selectionChange)="languagechange($event.value)"
          >
            <mat-option
              *ngFor="let option of hardcodedOptions"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card-header>
      <div style="margin-top: 0%"></div>
      <mat-card-content style="padding-left: 0%">
        <textarea matInput style="width: 104%; height: 622px">{{
          this.apiRequestData
        }}</textarea>
      </mat-card-content>
    </mat-card>
  </div>
</div>
